import {useSearchParams} from 'react-router-dom';
import React, {useEffect, useState} from 'react';
import {useProviderProfile} from "../../ProviderProfileProvider";
import {WelcomeToKensu} from "./WelcomeToKensu";
import {RpcState} from "../../util/RpcState";
import {useRpcSender} from "../../util/RpcSender";
import {CheckBusinessInviteRequest, CheckBusinessInviteResponse} from "../../provider_api";
import {useKensuAuth} from "../../util/authwrapper/AuthWrapper";

/**
 */
export const CheckBusinessInvite = () => {


  const [searchParams] = useSearchParams();
  const inviteCode = searchParams.get('inviteCode');

  const {loginWithRedirect} = useKensuAuth();
  const {business} = useProviderProfile();
  const rpcSender = useRpcSender();

  // This login redirects back to the redeem invite page...
  const auth0Login = () => {
    loginWithRedirect({
      appState: {
        returnTo: `/redeem?inviteCode=${inviteCode}`
      },
    });
  }

  // if the rpc is out
  const [rpcState, setRpcState] = useState<RpcState>({state: 'none'});
  const [rpcResponse, setRpcResponse] = useState<CheckBusinessInviteResponse>();

  // The effect for checking an invite code; this only happens if there is no authenticated user.
  useEffect(() => {

    // This invite only goes out if there's an invite code and it's been confirmed that
    // there is no authenticated user. This then checks whether the invite is valid.
    if (!inviteCode || business || rpcState.state != 'none') {
      return;
    }

    setRpcState({state: 'pending'})

    let request = CheckBusinessInviteRequest.encode(new CheckBusinessInviteRequest({
      inviteCode: inviteCode,
    })).finish();

    rpcSender.send('action/check_business_invite', request).then(r => {
      let response = CheckBusinessInviteResponse.decode(r);
      if (response.okay) {
        setRpcState({state: 'success'});
      } else {
        setRpcState({state: 'error', message: 'Server error checking invite.'});
      }
      setRpcResponse(response);
    }).catch(e => {
      console.log(e);
      setRpcState({state: 'error', message: 'Error checking your invite. Please try again later'});
    });

  }, [inviteCode]);


  if (rpcState.state == 'pending') {
    return <div>Looking up your invite...</div>
  }

  if (rpcState.state == 'success') {
    return <WelcomeToKensu onContinue={auth0Login}/>;
  }

  return <div className={'ErrorText'}>
    Error checking invite code. it may be invalid or expired
  </div>

}
